export {
  transformCarDataForPreviouslyViewed,
  transformLeasingCarDataForPreviouslyViewed,
  type PreviouslyViewedCar,
} from "./carDataTransform"
export {
  CarTypeId,
  CarTypeLabels,
  CarTypeOrder,
  CarTypeToClassificationCodes,
  getCarTypeFromClassificationCode,
  normalizeCarType,
  type CarType,
} from "./carTypeId"
export {
  filterPublishedBranches,
  findBranchImage,
  normalizeBranchNumber,
  type BranchImage,
} from "./branchPublishing"
export {
  buildClassificationMetadata,
  emptySearchMetadata,
  mergeSearchMetadata,
} from "./mergeSearchMetadata"
export {
  searchAcrossClassifications,
  searchAcrossSaleClassificationTypes,
  type ClassificationSearchPage,
} from "./searchAcrossClassifications"
export {
  fetchTermModelRefs,
  type TermModelRefs,
  type TermSearchItem,
} from "./searchTermModels"
export {
  carTypeDescriptionMapping,
  mapCarTypeToImage,
  type TypeImage,
} from "./carTypeImageMapping"
export { extractProperty } from "./extractProperty"
export {
  fetchCarConfigurationData,
  fetchLeasingConfigurationData,
  type ConfigurationData,
  type EngineGroup,
  type FinishLevel,
  type LeasingConfigurationData,
  type LeasingParams,
  type PackageOption,
  type Params,
  type TrimOption,
} from "./fetchConfigurationData"
export { filterManufacturersBySelection } from "./filterManufacturersBySelection"
export { getAlternateMetadataFromPathname } from "./getAlternateMeta"
export { getBrands } from "./getBrands"
export { getBreadCrumbs, type BreadCrumbs } from "./getBreadCrumbs"
export { getCarPageInfo, type CarPageInfo } from "./getCarPageInfo"
export { getNonUmbracoUrl } from "./getNonUmbracoUrl"
export { getUmbracoMediaUrl } from "./getUmbracoMediaUrl"
export { extractMetaTags } from "./metaTags"
export {
  cultureMap,
  getDirection,
  getPathname,
  Link,
  locales,
  redirect,
  routing,
  usePathname,
  useRouter,
  type Culture,
  type Locale,
} from "./routing"
export { transformProperties } from "./simplifyData"
export {
  transformCarFeatures,
  transformCarTypes,
  transformManufacturers,
} from "./transformMetadataFilters"

export {
  buildAboutPageSchema,
  buildArticleSchema,
  buildBreadcrumbListSchema,
  buildVehicleSchema,
  buildVideoObjectSchema,
  type SchemaOrgObject,
} from "./structuredData"
export { useLocalStorage } from "./useLocalStorage"
export { usePreviouslyViewed } from "./usePreviouslyViewed"
